export const translations = {
  en: {
    nav: {
      services: 'Services',
      portfolio: 'Portfolio',
      about: 'About',
      testimonials: 'Testimonials',
      contact: 'Contact',
    },
    hero: {
      title: 'AI-Powered Digital Solutions',
      subtitle: 'for Startups & Small Businesses',
      description: 'Professional websites delivered within 5 days. Transform your digital presence with our cutting-edge AI technology.',
      cta: 'Get Started',
      aiPowered: 'Powered by AI',
      weekDelivery: 'Delivery in 5 Days',
    },
    services: {
      title: 'Our Services',
      subtitle: 'Everything your business needs to thrive online',
      webDesign: {
        title: 'Web Design & Development',
        description: 'Custom websites tailored to your brand',
        items: [
          'Custom Website Design',
          'E-commerce Solutions',
          'Landing Pages',
          'Web Applications',
          'Responsive Design',
          'CMS Integration',
        ],
      },
      digitalMarketing: {
        title: 'Digital Marketing',
        description: 'Grow your audience and boost conversions',
        items: [
          'SEO Optimization',
          'Social Media Marketing',
          'Content Marketing',
          'PPC Advertising',
          'Email Marketing',
          'Analytics & Reporting',
        ],
      },
    },
    portfolio: {
      title: 'Featured Projects',
      subtitle: 'See what we\'ve built for our clients',
    },
    about: {
      title: 'About PrimeDigital',
      subtitle: 'Your trusted partner in digital transformation',
      description: 'We are a digital agency specializing in web design, development, and digital marketing for startups and small businesses. Our AI-powered approach ensures fast delivery without compromising quality.',
      stats: [
        { value: '100+', label: 'Projects Completed' },
        { value: '50+', label: 'Happy Clients' },
        { value: '7 Days', label: 'Average Delivery' },
        { value: '98%', label: 'Client Satisfaction' },
      ],
    },
    testimonials: {
      title: 'What Our Clients Say',
      subtitle: 'Trusted by startups and businesses worldwide',
    },
    contact: {
      title: 'Get In Touch',
      subtitle: 'Ready to start your project? Contact us today',
      namePlaceholder: 'Your Name',
      emailPlaceholder: 'Your Email',
      messagePlaceholder: 'Tell us about your project',
      submit: 'Send Message',
      or: 'Or reach us directly',
    },
    cart: {
      title: 'Shopping Cart',
      empty: 'Your cart is empty',
      total: 'Total',
      checkout: 'Proceed to Checkout',
      continueShopping: 'Continue Shopping',
      quantity: 'Quantity',
    },
    checkout: {
      title: 'Checkout',
      customerInfo: 'Customer Information',
      name: 'Full Name',
      email: 'Email Address',
      phone: 'Phone Number',
      paymentMethod: 'Payment Method',
      creditCard: 'Credit/Debit Card',
      paypal: 'PayPal',
      paypalComingSoon: 'Coming Soon',
      orderSummary: 'Order Summary',
      subtotal: 'Subtotal',
      total: 'Total',
      pay: 'Pay Now',
      processing: 'Processing...',
      backToCart: 'Back to Cart',
      secure: 'Secure Payment',
    },
    paymentSuccess: {
      title: 'Payment Successful!',
      message: 'Thank you for your order. We will contact you shortly to begin working on your project.',
      orderNumber: 'Order Number',
      backHome: 'Back to Home',
    },
    paymentCancel: {
      title: 'Payment Cancelled',
      message: 'Your payment was cancelled. No charges were made.',
      tryAgain: 'Try Again',
      backHome: 'Back to Home',
    },
    footer: {
      rights: 'All rights reserved',
      tagline: 'Empowering businesses with AI-driven digital solutions',
    },
  },
  es: {
    nav: {
      services: 'Servicios',
      portfolio: 'Portafolio',
      about: 'Nosotros',
      testimonials: 'Testimonios',
      contact: 'Contacto',
    },
    hero: {
      title: 'Soluciones Digitales Impulsadas por IA',
      subtitle: 'para Startups y Pequeñas Empresas',
      description: 'Sitios web profesionales entregados en 5 días. Transforma tu presencia digital con nuestra tecnología de IA de vanguardia.',
      cta: 'Comenzar',
      aiPowered: 'Impulsado por IA',
      weekDelivery: 'Entrega en 5 Días',
    },
    services: {
      title: 'Nuestros Servicios',
      subtitle: 'Todo lo que tu negocio necesita para prosperar en línea',
      webDesign: {
        title: 'Diseño y Desarrollo Web',
        description: 'Sitios web personalizados adaptados a tu marca',
        items: [
          'Diseño Web Personalizado',
          'Soluciones E-commerce',
          'Páginas de Aterrizaje',
          'Aplicaciones Web',
          'Diseño Responsivo',
          'Integración CMS',
        ],
      },
      digitalMarketing: {
        title: 'Marketing Digital',
        description: 'Haz crecer tu audiencia y aumenta las conversiones',
        items: [
          'Optimización SEO',
          'Marketing en Redes Sociales',
          'Marketing de Contenidos',
          'Publicidad PPC',
          'Email Marketing',
          'Análisis e Informes',
        ],
      },
    },
    portfolio: {
      title: 'Proyectos Destacados',
      subtitle: 'Mira lo que hemos construido para nuestros clientes',
    },
    about: {
      title: 'Sobre PrimeDigital',
      subtitle: 'Tu socio de confianza en transformación digital',
      description: 'Somos una agencia digital especializada en diseño web, desarrollo y marketing digital para startups y pequeñas empresas. Nuestro enfoque impulsado por IA garantiza una entrega rápida sin comprometer la calidad.',
      stats: [
        { value: '100+', label: 'Proyectos Completados' },
        { value: '50+', label: 'Clientes Satisfechos' },
        { value: '5 Días', label: 'Entrega Promedio' },
        { value: '98%', label: 'Satisfacción del Cliente' },
      ],
    },
    testimonials: {
      title: 'Lo Que Dicen Nuestros Clientes',
      subtitle: 'Confiado por startups y empresas en todo el mundo',
    },
    contact: {
      title: 'Contáctanos',
      subtitle: '¿Listo para comenzar tu proyecto? Contáctanos hoy',
      namePlaceholder: 'Tu Nombre',
      emailPlaceholder: 'Tu Email',
      messagePlaceholder: 'Cuéntanos sobre tu proyecto',
      submit: 'Enviar Mensaje',
      or: 'O contáctanos directamente',
    },
    cart: {
      title: 'Carrito de Compras',
      empty: 'Tu carrito está vacío',
      total: 'Total',
      checkout: 'Proceder al Pago',
      continueShopping: 'Continuar Comprando',
      quantity: 'Cantidad',
    },
    checkout: {
      title: 'Finalizar Compra',
      customerInfo: 'Información del Cliente',
      name: 'Nombre Completo',
      email: 'Correo Electrónico',
      phone: 'Número de Teléfono',
      paymentMethod: 'Método de Pago',
      creditCard: 'Tarjeta de Crédito/Débito',
      paypal: 'PayPal',
      paypalComingSoon: 'Próximamente',
      orderSummary: 'Resumen del Pedido',
      subtotal: 'Subtotal',
      total: 'Total',
      pay: 'Pagar Ahora',
      processing: 'Procesando...',
      backToCart: 'Volver al Carrito',
      secure: 'Pago Seguro',
    },
    paymentSuccess: {
      title: '¡Pago Exitoso!',
      message: 'Gracias por tu pedido. Nos pondremos en contacto contigo pronto para comenzar a trabajar en tu proyecto.',
      orderNumber: 'Número de Pedido',
      backHome: 'Volver al Inicio',
    },
    paymentCancel: {
      title: 'Pago Cancelado',
      message: 'Tu pago fue cancelado. No se realizaron cargos.',
      tryAgain: 'Intentar de Nuevo',
      backHome: 'Volver al Inicio',
    },
    footer: {
      rights: 'Todos los derechos reservados',
      tagline: 'Empoderando empresas con soluciones digitales impulsadas por IA',
    },
  },
  de: {
    nav: {
      services: 'Dienstleistungen',
      portfolio: 'Portfolio',
      about: 'Über uns',
      testimonials: 'Referenzen',
      contact: 'Kontakt',
    },
    hero: {
      title: 'KI-gestützte Digitale Lösungen',
      subtitle: 'für Startups & Kleine Unternehmen',
      description: 'Professionelle Websites innerhalb von 5 Tagen geliefert. Transformieren Sie Ihre digitale Präsenz mit unserer hochmodernen KI-Technologie.',
      cta: 'Jetzt Starten',
      aiPowered: 'KI-gestützt',
      weekDelivery: 'Lieferung in 5 Tagen',
    },
    services: {
      title: 'Unsere Dienstleistungen',
      subtitle: 'Alles, was Ihr Unternehmen braucht, um online erfolgreich zu sein',
      webDesign: {
        title: 'Webdesign & Entwicklung',
        description: 'Individuelle Websites für Ihre Marke',
        items: [
          'Individuelles Webdesign',
          'E-Commerce-Lösungen',
          'Landing Pages',
          'Webanwendungen',
          'Responsives Design',
          'CMS-Integration',
        ],
      },
      digitalMarketing: {
        title: 'Digitales Marketing',
        description: 'Steigern Sie Ihr Publikum und Ihre Conversions',
        items: [
          'SEO-Optimierung',
          'Social Media Marketing',
          'Content Marketing',
          'PPC-Werbung',
          'E-Mail-Marketing',
          'Analysen & Berichte',
        ],
      },
    },
    portfolio: {
      title: 'Ausgewählte Projekte',
      subtitle: 'Sehen Sie, was wir für unsere Kunden erstellt haben',
    },
    about: {
      title: 'Über PrimeDigital',
      subtitle: 'Ihr vertrauenswürdiger Partner für digitale Transformation',
      description: 'Wir sind eine Digitalagentur, die sich auf Webdesign, Entwicklung und digitales Marketing für Startups und kleine Unternehmen spezialisiert hat. Unser KI-gestützter Ansatz gewährleistet schnelle Lieferung ohne Qualitätskompromisse.',
      stats: [
        { value: '100+', label: 'Abgeschlossene Projekte' },
        { value: '50+', label: 'Zufriedene Kunden' },
        { value: '5 Tage', label: 'Durchschnittliche Lieferung' },
        { value: '98%', label: 'Kundenzufriedenheit' },
      ],
    },
    testimonials: {
      title: 'Was Unsere Kunden Sagen',
      subtitle: 'Vertraut von Startups und Unternehmen weltweit',
    },
    contact: {
      title: 'Kontaktieren Sie Uns',
      subtitle: 'Bereit, Ihr Projekt zu starten? Kontaktieren Sie uns noch heute',
      namePlaceholder: 'Ihr Name',
      emailPlaceholder: 'Ihre E-Mail',
      messagePlaceholder: 'Erzählen Sie uns von Ihrem Projekt',
      submit: 'Nachricht Senden',
      or: 'Oder kontaktieren Sie uns direkt',
    },
    cart: {
      title: 'Warenkorb',
      empty: 'Ihr Warenkorb ist leer',
      total: 'Gesamt',
      checkout: 'Zur Kasse',
      continueShopping: 'Weiter Einkaufen',
      quantity: 'Menge',
    },
    checkout: {
      title: 'Kasse',
      customerInfo: 'Kundeninformationen',
      name: 'Vollständiger Name',
      email: 'E-Mail-Adresse',
      phone: 'Telefonnummer',
      paymentMethod: 'Zahlungsmethode',
      creditCard: 'Kredit-/Debitkarte',
      paypal: 'PayPal',
      paypalComingSoon: 'Demnächst',
      orderSummary: 'Bestellübersicht',
      subtotal: 'Zwischensumme',
      total: 'Gesamt',
      pay: 'Jetzt Bezahlen',
      processing: 'Wird verarbeitet...',
      backToCart: 'Zurück zum Warenkorb',
      secure: 'Sichere Zahlung',
    },
    paymentSuccess: {
      title: 'Zahlung Erfolgreich!',
      message: 'Vielen Dank für Ihre Bestellung. Wir werden uns in Kürze mit Ihnen in Verbindung setzen, um mit Ihrem Projekt zu beginnen.',
      orderNumber: 'Bestellnummer',
      backHome: 'Zurück zur Startseite',
    },
    paymentCancel: {
      title: 'Zahlung Abgebrochen',
      message: 'Ihre Zahlung wurde abgebrochen. Es wurden keine Gebühren erhoben.',
      tryAgain: 'Erneut Versuchen',
      backHome: 'Zurück zur Startseite',
    },
    footer: {
      rights: 'Alle Rechte vorbehalten',
      tagline: 'Unternehmen mit KI-gestützten digitalen Lösungen stärken',
    },
  },
};

export const services = [
  {
    id: 'web-custom',
    category: 'web',
    name: { en: 'Custom Website Design', es: 'Diseño Web Personalizado', de: 'Individuelles Webdesign' },
    description: { en: 'Unique, brand-focused website design', es: 'Diseño web único y centrado en la marca', de: 'Einzigartiges, markenzentriertes Webdesign' },
    price: 1499,
  },
  {
    id: 'web-ecommerce',
    category: 'web',
    name: { en: 'E-commerce Solution', es: 'Solución E-commerce', de: 'E-Commerce-Lösung' },
    description: { en: 'Full online store with payment integration', es: 'Tienda online completa con integración de pagos', de: 'Vollständiger Online-Shop mit Zahlungsintegration' },
    price: 2499,
  },
  {
    id: 'web-landing',
    category: 'web',
    name: { en: 'Landing Page', es: 'Página de Aterrizaje', de: 'Landing Page' },
    description: { en: 'High-converting single page', es: 'Página única de alta conversión', de: 'Hochkonvertierende Einzelseite' },
    price: 799,
  },
  {
    id: 'web-app',
    category: 'web',
    name: { en: 'Web Application', es: 'Aplicación Web', de: 'Webanwendung' },
    description: { en: 'Custom web app development', es: 'Desarrollo de aplicación web personalizada', de: 'Individuelle Webanwendungsentwicklung' },
    price: 3499,
  },
  {
    id: 'marketing-seo',
    category: 'marketing',
    name: { en: 'SEO Optimization', es: 'Optimización SEO', de: 'SEO-Optimierung' },
    description: { en: 'Monthly SEO services to boost rankings', es: 'Servicios SEO mensuales para mejorar posicionamiento', de: 'Monatliche SEO-Dienste zur Ranking-Steigerung' },
    price: 499,
    recurring: true,
  },
  {
    id: 'marketing-social',
    category: 'marketing',
    name: { en: 'Social Media Management', es: 'Gestión de Redes Sociales', de: 'Social Media Management' },
    description: { en: 'Complete social media strategy & management', es: 'Estrategia y gestión completa de redes sociales', de: 'Komplette Social-Media-Strategie & Management' },
    price: 699,
    recurring: true,
  },
  {
    id: 'marketing-ppc',
    category: 'marketing',
    name: { en: 'PPC Advertising', es: 'Publicidad PPC', de: 'PPC-Werbung' },
    description: { en: 'Google Ads & Facebook Ads management', es: 'Gestión de Google Ads y Facebook Ads', de: 'Google Ads & Facebook Ads Verwaltung' },
    price: 899,
    recurring: true,
  },
  {
    id: 'marketing-content',
    category: 'marketing',
    name: { en: 'Content Marketing', es: 'Marketing de Contenidos', de: 'Content Marketing' },
    description: { en: 'Blog posts, articles, and content strategy', es: 'Posts de blog, artículos y estrategia de contenido', de: 'Blog-Beiträge, Artikel und Content-Strategie' },
    price: 599,
    recurring: true,
  },
];

export const portfolioProjects = [
  {
    id: 1,
    name: { en: 'TechStart Platform', es: 'Plataforma TechStart', de: 'TechStart Plattform' },
    description: { en: 'Modern SaaS platform for startup management', es: 'Plataforma SaaS moderna para gestión de startups', de: 'Moderne SaaS-Plattform für Startup-Management' },
    category: { en: 'Web Application', es: 'Aplicación Web', de: 'Webanwendung' },
    bgColor: '#b7fbff',
  },
  {
    id: 2,
    name: { en: 'FreshBite Restaurant', es: 'Restaurante FreshBite', de: 'FreshBite Restaurant' },
    description: { en: 'E-commerce food ordering platform', es: 'Plataforma de pedidos de comida e-commerce', de: 'E-Commerce-Bestellplattform für Lebensmittel' },
    category: { en: 'E-commerce', es: 'E-commerce', de: 'E-Commerce' },
    bgColor: '#f6fd87',
  },
  {
    id: 3,
    name: { en: 'FitLife Gym', es: 'Gimnasio FitLife', de: 'FitLife Fitnessstudio' },
    description: { en: 'Complete digital marketing campaign', es: 'Campaña completa de marketing digital', de: 'Komplette digitale Marketingkampagne' },
    category: { en: 'Digital Marketing', es: 'Marketing Digital', de: 'Digitales Marketing' },
    bgColor: '#78d692',
  },
  {
    id: 4,
    name: { en: 'LuxStyle Fashion', es: 'Moda LuxStyle', de: 'LuxStyle Mode' },
    description: { en: 'High-end fashion e-commerce store', es: 'Tienda e-commerce de moda de alta gama', de: 'High-End-Mode-E-Commerce-Shop' },
    category: { en: 'E-commerce', es: 'E-commerce', de: 'E-Commerce' },
    bgColor: '#ffd1e7',
  },
  {
    id: 5,
    name: { en: 'GreenEnergy Co', es: 'GreenEnergy Co', de: 'GreenEnergy Co' },
    description: { en: 'Corporate website with SEO optimization', es: 'Sitio web corporativo con optimización SEO', de: 'Unternehmenswebsite mit SEO-Optimierung' },
    category: { en: 'Website + SEO', es: 'Sitio Web + SEO', de: 'Website + SEO' },
    bgColor: '#88a2ff',
  },
  {
    id: 6,
    name: { en: 'ArtSpace Gallery', es: 'Galería ArtSpace', de: 'ArtSpace Galerie' },
    description: { en: 'Interactive portfolio website', es: 'Sitio web de portafolio interactivo', de: 'Interaktive Portfolio-Website' },
    category: { en: 'Website', es: 'Sitio Web', de: 'Website' },
    bgColor: '#d987ff',
  },
];

export const testimonials = [
  {
    id: 1,
    name: 'María González',
    company: 'TechStart',
    text: { 
      en: 'PrimeDigital delivered our platform in just 6 days! The quality exceeded our expectations and the AI-powered features are incredible.',
      es: '¡PrimeDigital entregó nuestra plataforma en solo 6 días! La calidad superó nuestras expectativas y las características impulsadas por IA son increíbles.',
      de: 'PrimeDigital lieferte unsere Plattform in nur 6 Tagen! Die Qualität übertraf unsere Erwartungen und die KI-gestützten Funktionen sind unglaublich.',
    },
    rating: 5,
  },
  {
    id: 2,
    name: 'John Smith',
    company: 'FreshBite',
    text: {
      en: 'Outstanding service! Our online orders increased by 300% after the new website launch. Highly recommend PrimeDigital.',
      es: '¡Servicio excepcional! Nuestros pedidos online aumentaron un 300% después del lanzamiento del nuevo sitio web. Recomiendo altamente PrimeDigital.',
      de: 'Hervorragender Service! Unsere Online-Bestellungen stiegen nach dem Start der neuen Website um 300%. Kann PrimeDigital nur empfehlen.',
    },
    rating: 5,
  },
  {
    id: 3,
    name: 'Sophie Weber',
    company: 'FitLife Gym',
    text: {
      en: 'The digital marketing campaign generated 150 new members in the first month. Professional team and excellent results.',
      es: 'La campaña de marketing digital generó 150 nuevos miembros en el primer mes. Equipo profesional y excelentes resultados.',
      de: 'Die digitale Marketingkampagne brachte im ersten Monat 150 neue Mitglieder. Professionelles Team und ausgezeichnete Ergebnisse.',
    },
    rating: 5,
  },
];
